import React from "react";

function useWorkloads() {
  const [areWorkloadsToggled, setAreWorkloadsToggled] = React.useState(false);
  const [areWorkloadsGroupsToggled, setAreWorkloadsGroupsToggled] =
    React.useState(false);

  return {
    areWorkloadsToggled,
    areWorkloadsGroupsToggled,
    toggleWorkloads: () => setAreWorkloadsToggled((isToggled) => !isToggled),
    toggleWorkloadsGroups: () =>
      setAreWorkloadsGroupsToggled((isToggled) => !isToggled),
  };
}

export { useWorkloads };
